// extracted by mini-css-extract-plugin
export default {"sidebar":"Sidebar_sidebar__M8peW","sidebar_wrapper":"Sidebar_sidebar_wrapper__-3teD","separation_line":"Sidebar_separation_line__tkeS4","social_links":"Sidebar_social_links__-ZTFp"};